<template >
    <div>
        <b-row>
            <b-col sm="12" lg="8">
                <InputField
                    type="text"
                    name="cardholder_name"
                    :label="this.$t('cardHolderName')"
                    v-model="creditcard.name"
                    @error="onError"
                    :rules="{
                        required: true
                    }"
                />

                <InputField
                    type="text"
                    name="card_number"
                    :label="this.$t('creditCardNumber')"
                    :descrption="this.$t('creditCardNumberWithoutSpaces')"
                    v-model="creditcard.number"
                    @error="onError"
                    :rules="{
                        required: true,
                        placeholder: '************4321',
                        length: {
                            min: 16
                        }
                    }"
                    maxLength="16"
                />

                <b-row>
                    <b-col sm="6">
                    <b-form-group >
                        <InputField
                            type="text"
                            name="expires"
                            :label="this.$t('expires')"
                            v-model="creditcard.expires"
                            @error="onError"
                            :rules="{
                                required: true,
                                placeholder: 'mm/yy',
                                length: {
                                    min: 5,
                                    max: 5
                                }
                            }"
                            maxLength="5"
                        />
                    </b-form-group>
                    </b-col>

                    <b-col sm="6">
                    <b-form-group >
                        <InputField
                            type="text"
                            name="cvv"
                            :label="this.$t('cvv')"
                            v-model="creditcard.cvv"
                            @error="onError"
                            :rules="{
                                required: true,
                                length: {
                                    min: 3,
                                    max: 4
                                }
                            }"
                            maxLength="4"
                        />
                    </b-form-group>
                    </b-col>

                </b-row>
            </b-col>
            <b-col sm="12" lg="4">
                <slot name="sidebar"></slot>

                <img src="/img/256bit.png" width="100%"/>
                <img src="/img/2checkout-logo.png" width="100%"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Input from "@/components/form/Input"

export default {
    name: 'PaymentInfo',
    components: {
        InputField: Input
    },
    props: {
        value: {
            type: Object
        }
    },
    data: function() {
        return {
            errors: {}
        }
    },
    computed: {
        creditcard: {
            get() {
                return this.value
            },

            set(val) {
                //console.log(val)

                this.$emit("input", val)
            }
        }
    },
    watch: {
        "creditcard.expires": function(n, o) {
             if (n.length == 2) {
                this.creditcard.expires += "/"
            }
        }
    },
    methods: {
        onError(e) {
            this.errors[e.field] = e.error

            let hasErrors = true
            Object.keys(this.errors).forEach(k => {
                const status = this.errors[k]

                if (status) {
                    hasErrors = true
                    return
                }

                hasErrors = false
            })


            if (!hasErrors) {
                console.log("NO ERRORS")
                this.$emit('success')
            } else {
                this.$emit('error')
            }
        } 
    }
}
</script>
